// extracted by mini-css-extract-plugin
export default {"custom-modal-div":"customModal_custom-modal-div__yNDuf","custom-modal-content":"customModal_custom-modal-content__cb9Ee"};